import Vue from 'vue';
import Photos from '@global/components/product_vue/photos';
import Price from '@global/components/product_vue/Price';
import ColorButton from '@global/components/product_vue/ColorButton';
import SelectSize from '@global/components/global/Select_vue';
import Quantity from '@global/components/product_vue/Ui_quantity';
import BuyButton from '@global/components/product_vue/BuyButton';
import Ootd from '@global/components/product_vue/ootd';
import ProductInfo from '@global/components/product_vue/ProductInfo';
import WhishlistBtn from '@global/components/product_vue/whishlistBtn_vue';
import imgTransfer from '@global/helpers/imgTransfer';
import AlertDialog from '@global/helpers/alertDialog';
import modal from 'bootstrap/js/dist/modal';
import axios from 'axios';
import Addon from '@page/productPage/components/addon.vue';
import StockMobile from '@page/productPage/components/StockMobile.vue';
import store from '@global/components/store/index';
import Recommend from '@page/productPage/components/Recommend.vue';
import $ from 'jquery';
import { fireShopContentView } from '@global/gtm/product';
import setEnv from '@global/helpers/setEnv';
import { mapState, mapActions, mapMutations } from 'vuex';

if (process.env.NODE_ENV === 'development') {
  Vue.config.devtools = true;
}

function RenderProductPageContent() {
  const productRender = new Vue({
    el: '#product-render',
    store,
    components: {
      Photos,
      Price,
      ColorButton,
      SelectSize,
      Quantity,
      BuyButton,
      Ootd,
      ProductInfo,
      Recommend,
      WhishlistBtn,
      Addon,
      StockMobile,
    },
    data: {
      isMobile: setEnv.myEquipment(),
      CustomMarketID: window.CustomMarketID.substring(0, window.CustomMarketID.indexOf('CL')),
      theProductDataNew: {},
      colorIndex: 0, // 當前顯示的顏色在JSON中的序號,
      colorID: window.CustomMarketID.substring(
        window.CustomMarketID.indexOf('CL') + 2,
        window.CustomMarketID.indexOf('SZ'),
      ),
      barcode: '', // 含色碼與尺寸碼的完整八扣，預設一進來是未選取Size 故設定為空自串
      sizeName: '',
      sizeIndex: -1, // 當前尺寸序號，以網址判斷，沒有的話-1
      sizeID: '',
      sizeData: [],
      buyAmount: 1, // 當前購買數量 預設1
      totalQty: 0,
      ones: true, // 第一次觸發componentDidUpdate改為 false
      isPreOrderProduct: false,
      isFuture: false,
      futureTime: [],
      photoSizeLogic: '|',
      photoSizeLogic_2: '_w136_h174|',
      NowMyEquipment: window.nowEnv.NowMyEquipment,
      NowMyStorage: window.nowEnv.NowMyStorage,
      productName: '',
      subtitle: '',
      sizeReportData: '',
      todayViewDataAry: [],
      todayViewBarcodes: [],
      sizeSelectOptions: [],
      theColorPhotoAry: [],
      theColorZoomAry: [],
      theColorStaffAry: [],
      theColorStaffZoomAry: [],
      categoryListData: [],
      theCategoryList: [],
      isFavorite: false,
      favoriteState: [],
      sizeReportOpened: false,
      nowColorImage: '',
      aqIsLoad: window.aqIsLoad,
      isShowBranchStock: window.ShowBranchStock,
    },
    computed: {
      ...mapState('shopContent', ['isOpenStockDialog', 'selectedDataID']),
      nowText: function () {
        return this.barcode === ''
          ? null
          : `${this.sizeName}${this.isPreOrderProduct ? ' (預)' : ''}`;
      },
    },
    watch: {
      selectedDataID() {
        this.getSelectedData();
      },
    },
    created() {
      this.getData();
      this.initTodayView();
    },
    mounted() {
      $('body').css({ background: 'none' });
      if (!this.NowMyEquipment) {
        setTimeout(() => {
          $('.product-content.product-content--pdpage').css(
            'min-height',
            $('.product-menu').height(),
          );
        }, 0);
        $('.product-details').stick_in_parent({
          offset_top: 128,
        });
        setTimeout(() => {
          $('.product-details').trigger('sticky_kit:recalc');
        }, 2000);
      }
      $('#sizeGuide').modal('hide');
    },
    update() {
      if (this.ones === true) {
        if (!this.NowMyEquipment) {
          setTimeout(() => {
            $('.product-content.product-content--pdpage').css(
              'min-height',
              $('.product-menu').height(),
            );
          }, 0);
          $('.product-details').stick_in_parent({
            offset_top: 128,
          });
        }
        this.ones = false;
      }
    },
    methods: {
      ...mapMutations('shopContent', ['showMobileStockDialog', 'setItemData', 'changeSelected']),
      ...mapActions('shopContent', ['selectSpec', 'getSelectedData']),
      getData() {
        axios
          .get(API_URL.MARKET_CONTENT, {
            params: {
              CustomMarketID: window.CustomMarketID,
            },
          })
          .then((response) => {
            const res = response.data;

            if (res.Code === 200) {
              this.productName = res.Response.Name;
              this.theProductDataNew = res.Response;
              this.subtitle = res.Response.SubTitle;
              this.setItemData(res.Response);
              this.initFavoriteState();
              this.initColorIndex();
              this.sizeSelectOptions = this.createSizeSelectOptions(
                res.Response.Colors[this.colorIndex].Specs,
              );

              if (this.sizeSelectOptions[0].text === 'F') {
                this.onChangeSize(res.Response.Colors[this.colorIndex].Specs[0]);
                this.handleChangeSize(res.Response.Colors[this.colorIndex].Specs[0].Barcode);
              }

              return res.Response;
            }

            AlertDialog.alert('系統忙線中,請稍後再試');
            throw new Error('系統忙線中,請稍後再試');
          })
          .then((res) => {
            this.initPhotoArray();

            fireShopContentView({
              affiliation: res.Colors[this.colorIndex].Name,
              customMarketID: res.CustomMarketID,
              eventName: res.Events.length ? res.Events[0].Name : '',
              name: res.Name,
              price: res.EventPrice > 0 ? res.EventPrice : res.SellPrice,
            });
          })
          .catch(() => {
            AlertDialog.alert('系統忙線中,請稍後再試');
          });
      },
      initFavoriteState() {
        const colorData = this.theProductDataNew.Colors;
        const favoriteState = colorData.map((data) => data.IsFavorite);
        this.favoriteState = favoriteState;
      },
      initFeaturedArray() {
        const theCategoryListAry = this.categoryListData.map((data) => {
          return { Image: data.Cover, LinkUrl: data.MarketUrl };
        });
        this.theCategoryList = theCategoryListAry;
      },
      initColorIndex() {
        let colorIndex;

        for (let i = 0; i < this.theProductDataNew.Colors.length; i++) {
          if (this.theProductDataNew.Colors[i].ID === parseInt(this.colorID)) {
            colorIndex = i;
            break;
          }
        }

        this.colorIndex = colorIndex;
        this.isFavorite = this.favoriteState[colorIndex];
        this.nowColorImage = this.theProductDataNew.Colors[colorIndex].Images[0].Url;
      },
      initPhotoArray() {
        // 整理圖片資料
        const colorData = this.theProductDataNew.Colors;
        let theColorPhotoAry = [];
        let theColorPhotoAry_new = [];
        let theColorZoomAry = [];
        let theColorStaffAry = [];
        let theColorStaffAry_new = [];
        let theColorStaffZoomAry = [];
        // 桌G版 需要整理圖片與 要放大圖片的陣列
        for (let i = 0, len = colorData.length; i < len; i++) {
          // 顏色
          theColorPhotoAry[i] = [];
          theColorPhotoAry_new[i] = [];
          theColorZoomAry[i] = [];

          theColorStaffAry[i] = [];
          theColorStaffAry_new[i] = [];
          theColorStaffZoomAry[i] = [];

          const colorImages_old = colorData[i].Images.map((data) => {
            if (data.Category === 0) {
              return data;
            } else {
              return null;
            }
          });

          const staffImages_old = colorData[i].Images.map((data) => {
            if (data.Category === 10) {
              return data;
            } else {
              return null;
            }
          });

          const colorImages = colorImages_old.filter((data) => data !== null);
          const staffImages = staffImages_old.filter((data) => data !== null);
          // 每個顏色下的每個模塊要顯示的中圖片在這
          theColorPhotoAry[i] = colorImages;
          theColorStaffAry[i] = staffImages;
          // 加入了要呈現的圖片

          // 開始處裡要放大的圖片的陣列
          const smallSuffix = this.photoSizeLogic.split('|')[0]; // 小圖尾綴
          const bigSuffix = this.photoSizeLogic.split('|')[1]; // 大圖尾綴
          const smallSuffix2 = this.photoSizeLogic_2.split('|')[0]; // 小圖尾綴
          const bigSuffix2 = this.photoSizeLogic_2.split('|')[1]; // 大圖尾綴
          // 顏色照片的放大
          for (let j = 0; j < colorImages.length; j++) {
            let photoUrl = colorImages[j].Url; // 完整URL(未編輯)
            if (photoUrl !== undefined) {
              let video_zoom = nowEnv.NowMyEquipment
                ? colorImages[j].VideoMUrl
                : colorImages[j].VideoUrl;
              theColorZoomAry[i].push(
                video_zoom !== undefined && video_zoom.length !== 0
                  ? imgTransfer(video_zoom, '')
                  : imgTransfer(colorImages[j].Url, ''),
              );
              theColorPhotoAry_new[i].push({
                imgUrl: imgTransfer(colorImages[j].Url, nowEnv.NowMyEquipment ? smallSuffix : ''),
                VideoUrl: imgTransfer(colorImages[j].VideoUrl, ''),
                VideoMUrl: imgTransfer(colorImages[j].VideoMUrl, ''),
              });
            }
          }

          for (let j = 0; j < staffImages.length; j++) {
            let photoUrl = staffImages[j].Url; // 完整URL(未編輯)
            if (photoUrl !== undefined) {
              // 如果不是undefined才要push
              let photoUrl_zoom = imgTransfer(photoUrl, bigSuffix);
              theColorStaffZoomAry[i].push(photoUrl);
              theColorStaffAry_new[i].push({
                imgUrl: staffImages[j].Url,
                VideoUrl: imgTransfer(staffImages[j].VideoUrl, ''),
                VideoMUrl: imgTransfer(staffImages[j].VideoMUrl, ''),
              });
            }
          }
        }

        this.theColorPhotoAry = theColorPhotoAry_new; // 要呈現的圖片們都已經整理好
        this.theColorZoomAry = theColorZoomAry; // 放大後輪播的陣列，由子輩ProductPhotos模快控制該陣列內容
        this.theColorStaffAry = theColorStaffAry_new; // 要呈現的圖片們都已經整理好
        this.theColorStaffZoomAry = theColorStaffZoomAry; // 放大後輪播的陣列，由子輩ProductPhotos模快控制該陣列內容
      },
      initTodayView() {
        let todayViewBarcodes = [];
        let todayViewDataAry = [];
        // 今日流覽
        if (!window.navigator.cookieEnabled) {
        } else if (window.localStorage.TodayViews) {
          todayViewBarcodes = ['P400060270102', 'P403012150900'];
        }

        // 陣列變字串
        if (todayViewBarcodes.length !== 0) {
          $.ajax({
            url: API_URL.DetailByBarcode,
            type: 'GET',
            data: { barcode: todayViewBarcodes.join() },
            dataType: 'json',
            async: false,
          }).done((data) => {
            todayViewDataAry = data.map((node, index) => {
              let photoUrl = data[index].imgurl;
              return {
                LinkUrl: data[index].linkurl,
                Image: photoUrl.replace(/\d{1}DM?.\D{3}$/g, '1M.jpg'),
                // 因為 (數字一位)+DM結尾 的圖片是橫的，將它取代為 1M結尾即可
              };
            });
          });
        }
        this.todayViewBarcodes = todayViewBarcodes;
        this.todayViewDataAry = todayViewDataAry; // 今日流覽過的商品資料
      },
      handleChangeFavoriteState(index) {
        this.favoriteState[index] = !this.favoriteState[index];
        this.isFavorite = this.favoriteState[this.colorIndex];
      },
      handleChangeColor(index) {
        // 修改當前瀏覽顏色序號
        const sizesData = this.theProductDataNew.Colors[index].Specs;
        const sizeIndex = sizesData.findIndex((size) => size.Name === this.sizeName);

        this.updateSizeSelectOptions(index);
        this.onChangeSize(sizesData[sizeIndex]);

        this.colorIndex = index;
        this.colorID = this.theProductDataNew.Colors[index].ID;
        this.nowColorImage = this.theProductDataNew.Colors[index].Images[0].Url;
        this.barcode = sizeIndex === -1 ? '' : sizesData[sizeIndex].Barcode;
        this.sizeIndex = sizeIndex;
        this.buyAmount = 1;
        this.isFavorite = this.favoriteState[this.colorIndex];
        this.changeSelected(this.colorID);

        setTimeout(() => {
          $('.product-details').trigger('sticky_kit:recalc');
        }, 2000);
      },
      onChangeSize(sizeData) {
        this.checkIsPreOrderProduct(sizeData);
        this.updateTotalQty(sizeData);
        this.sizeData = sizeData;

        if (this.sizeData !== undefined) {
          this.sizeID = sizeData.Key;
        } else {
          this.sizeID = '';
        }

        this.colorID = this.theProductDataNew.Colors[this.colorIndex].ID;
        if (sizeData) {
          this.selectSpec(sizeData);
        }
      },
      updateTotalQty(sizeData) {
        const totalQty = $.isEmptyObject(sizeData)
          ? 0
          : sizeData.PreOrder && sizeData.Stock < 1
          ? sizeData.Stock
          : sizeData.Stock;
        this.totalQty = totalQty;
      },
      checkIsPreOrderProduct(sizeData) {
        const isPreOrderProduct = $.isEmptyObject(sizeData) ? false : sizeData.PreOrder;
        this.isPreOrderProduct = isPreOrderProduct;
      },
      checkIsFuture(index) {
        let isFuture = false;
        let futureTime = [];
        const enabledDt = this.theProductData.Colors[index].EnabledDt;

        if (this.serverTime && enabledDt) {
          futureTime = enabledDt.split(',');
          const futureEnabledDt = new Date(
            futureTime[0],
            futureTime[1] - 1, // 月份要-1
            futureTime[2],
            futureTime[3],
            futureTime[4],
            futureTime[5],
          ).getTime();

          if (this.serverTime < futureEnabledDt) {
            isFuture = true;
          }
        }

        this.futureTime = futureTime;
        this.isFuture = isFuture;
      },
      handleChangeSize(barcode) {
        const sizesData = this.theProductDataNew.Colors[this.colorIndex].Specs;

        let sizeName;
        let sizeIndex;
        for (let i = 0, len = sizesData.length; i < len; i++) {
          if (sizesData[i].Barcode === barcode) {
            sizeName = sizesData[i].Name;
            sizeIndex = i;
            break;
          }
        }
        this.onChangeSize(sizesData[sizeIndex]);
        this.barcode = barcode;
        this.sizeName = sizeName;
        this.sizeIndex = sizeIndex;
        this.buyAmount = 1;
      },
      handleChangeAmount(amount) {
        this.buyAmount = amount;
      },
      createSizeSelectOptions(sizes) {
        return sizes.map((size) => {
          let text = size.Name;
          let isWeak = false;

          if (size.PreOrder) {
            text += ' (預)'; // 預購加字
          }
          if (size.Stock < 1) {
            isWeak = true;
          }

          return {
            value: size.Barcode,
            text,
            isWeak,
          };
        });
      },
      updateSizeSelectOptions(index) {
        this.sizeSelectOptions = this.createSizeSelectOptions(
          this.theProductDataNew.Colors[index].Specs,
        );
      },
      showSizeReport() {
        if (this.NowMyEquipment) {
          // 手機
          $(this.sizeReport).slideToggle();
        } else {
          $('#sizeGuide').modal('show');
        }
      },
      showProductInfo(index) {
        var $tabsContentDiv = $('.tabs__content div');
        var $tabsContentLi = $('.tabs__nav>li');
        $('#mobile-report-content').slideUp('fast');
        $tabsContentDiv.addClass('hide');
        $tabsContentLi.removeClass('tag');
        $tabsContentLi.eq(index).addClass('tag');
        $tabsContentDiv.eq(index).removeClass('hide');
        $('.product-details').trigger('sticky_kit:recalc');
      },
      openPopup() {
        var $tabsContentDiv = $('.tabs__content div');
        var $tabsContentLi = $('.tabs__nav>li');
        $('.size-guide__section').each(function () {
          if (!$(this).find('td').length) {
            $(this).hide();
          }
        });
        if (nowEnv.NowMyEquipment) {
          $tabsContentDiv.addClass('hide');
          $tabsContentLi.removeClass('tag');
          $tabsContentLi.eq(2).addClass('tag');
          this.toggleContent();
          return;
        }
        $('#size-report').modal('show');

        if (!this.sizeReportOpened) {
          $('.size-guide__content').hide();
          $('.size-guide').find('.size-guide__content').eq(0).show();
          $('.size-guide__section>h2').click(function () {
            $(this)
              .parents('.size-guide__section')
              .siblings()
              .find('.size-guide__content')
              .slideUp();
            $(this).parents('.size-guide__section').find('.size-guide__content').slideToggle();
          });
          this.sizeReportOpened = true;
        }
      },
      toggleContent() {
        $('#mobile-report-content').slideDown('fast');
      },
    },

    template: `
      <div :class="theColorPhotoAry.length > 0 ?'': 'loading'">
      <div id="size-report" class="modal fade" tabindex="-1">
          <div class="modal-dialog" role="document" style="max-width:800px">
              <div class="modal-content">
                  <div class="modal-header">
                      <a href="#" data-dismiss="modal" class="r-lightbox__close"></a>
                  </div>
                  <div class="modal-body">
                      <div v-html="theProductDataNew.SizeReport"></div>
                  </div>
              </div>
          </div>
      </div>
      <div id="productArea">
          <div v-if="NowMyEquipment" class='product-info'>
              <h1 class='product-title'>{{ productName }}</h1>
              <h2 class='product-title-en'>{{ subtitle }}</h2>
          </div>
          <Photos v-if="NowMyEquipment && theColorPhotoAry.length>0" :specifyClassName="'product-cover-photo'"
              :nowColorPhotoAry="theColorPhotoAry[colorIndex].slice(0,1)" :sizeLogic=photoSizeLogic
              :NowMyEquipment=NowMyEquipment :zoom="true" :nowColorZoomAry="theColorZoomAry[colorIndex]" />
          <div class='product-details'>
              <div v-if="!NowMyEquipment" class='product-info'>
                  <h1 class='product-title'>{{ productName }}</h1>
                  <h2 class='product-title-en'>{{ subtitle }}</h2>
              </div>
              <Price :productData=theProductDataNew v-if="theColorPhotoAry.length > 0" />
              <div v-if="isPreOrderProduct">
                  <div class='product-PreoderDAY'>
                      <span class='date'>{{ theProductDataNew.ArrivalExplanation }}</span>
                  </div>
              </div>
              <hr />
              <div class='product-color'>
                  <span class='product-color__current' v-if="theProductDataNew.Colors">
                      COLOR : {{ theProductDataNew.Colors[colorIndex].Name }}
                  </span>
                  <div class='product-barcode'>
                      {{ barcode || '尚未選擇尺寸' }}
                  </div>
                  <ColorButton v-if="theProductDataNew.Colors" :productColorsData="theProductDataNew.Colors"
                      :colorIndex=colorIndex @handleChangeColor="handleChangeColor" />
              </div>
              <p v-if='totalQty !==0 && totalQty < 10' class="solid-out-text my-2">即將售完</p>
              <SelectSize :options="sizeSelectOptions" :nowValue=barcode :nowText=nowText defaultText='SIZE'
                  v-on:onChangeValue="handleChangeSize" id='sizeSelect' :isDropDown="!NowMyEquipment" />
              <div class="hasStock">
              <Quantity :limit="!!theProductDataNew.Limit?theProductDataNew.Limit:totalQty" :nowValue="buyAmount"
                v-on:onChangeAmount="handleChangeAmount" />
                <div
                  v-if="isShowBranchStock"
                  class="shop-store-btn"
                  @click.prevent="showMobileStockDialog"
                >
                  <img src="https://static.tpx.tw/sff/mercci22/static/img/url-logo.webp" alt="" />
                  門市庫存
                </div>
              </div>
              <div class='BuyAndWish'>
                  <BuyButton v-if="theProductDataNew.CustomMarketID" :CustomMarketID=theProductDataNew.CustomMarketID
                      :barcode=barcode :productName=productName :productColor=theProductDataNew.Colors[colorIndex].Name
                      :sizeName=sizeName :buyAmount=buyAmount :sizeData=sizeData
                      :onSaleCode="theProductDataNew.Events.length > 0 ? theProductDataNew.Events[0].ID : ''"
                      :sellingPrice=theProductDataNew.OriginPrice :eventPrice=theProductDataNew.EventPrice
                      :discountPrice="theProductDataNew.Events ? theProductDataNew.SellPrice : theProductDataNew.OriginPrice"
                      :isCosmetic=theProductDataNew.IsCosmetic
                      :extendText="theProductDataNew.IsCosmetic ? {askNotice: '謝謝支持 ♡ 已全數完售'} : null"
                      :memberID=theProductDataNew.MemberSN :colorID=colorID :sizeID=sizeID
                      :linkUrl=theProductDataNew.MarketUrl :productImage=nowColorImage
                      :isPreShow=theProductDataNew.IsPreShow />
                  <WhishlistBtn v-if="theProductDataNew.CustomMarketID" :CustomMarketID="theProductDataNew.CustomMarketID" :isFavorite="isFavorite" 
                  :colorID="colorID" :colorIndex="colorIndex" @handleChangeFavoriteState="handleChangeFavoriteState" 
                  :selectedColor="theProductDataNew.Colors[colorIndex].Name" :productName="productName" 
                  :productSellPrice="theProductDataNew.EventPrice > 0 ? theProductDataNew.EventPrice : theProductDataNew.SellPrice" />
              </div>
              <div class='product-summary'>
                  <ul class='tabs__nav clearfix'>
                      <li class='tag'>
                          <a @click.prevent="showProductInfo(0)"><span>DESCRIPTION</span>商品描述</a>
                      </li>
                      <li>
                          <a @click.prevent="showProductInfo(1)"
                              v-html="theProductDataNew.IsCosmetic ? '<span>ATTENTION</span>注意事項' : '<span>LAUNDRY</span>洗滌說明'">
                          </a>
                      </li>
                      <li>
                          <a @click.prevent="openPopup">
                              <span>SIZE GUIDE</span>尺寸指南
                          </a>
                      </li>
                  </ul>
                  <div v-if="NowMyEquipment" id="mobile-report-content" class="hide"
                      v-html="theProductDataNew.SizeReport"></div>
                  <div class='tabs__content'>
                      <div>
                          <p>*實品顏色依單品照為主</p>
                          <p v-html=theProductDataNew.MaterialDescription />
                          <p>{{'素材產地 / ' + theProductDataNew.MaterialOriginDescription}}</p>
                          <p>{{'加工產地 / ' + theProductDataNew.OriginDescription}}</p>
                          <p v-html="theProductDataNew.Description" />
                      </div>
                      <div class='hide'>
                          <p v-html="theProductDataNew.CareLabelDesc" />
                      </div>
                  </div>
              </div>
              <div v-if="!isMobile" class="addon-pc">
                  <Addon :marketID="CustomMarketID">
              </div>
          </div>
          <div class="product-image-container">
              <Photos v-if="theColorPhotoAry.length>0"
                  :specifyClassName="NowMyEquipment ? 'product-photos__jumbo' : 'product-photos__model'"
                  :nowColorPhotoAry="theColorPhotoAry[colorIndex]" :sizeLogic=photoSizeLogic
                  :NowMyEquipment=NowMyEquipment :zoom="true" :nowColorZoomAry="theColorZoomAry[colorIndex]" />
              <div class='product-photos__mc22'>MERCCI22 TEAM WORK.</div>
              <div class='product-lookplus'>
                  <Recommend :productName="productName" />
              </div>
          </div>
          <div v-if="isMobile" class="addon-mobile">
              <Addon :marketID="CustomMarketID">
          </div>
          <StockMobile 
            v-if="isOpenStockDialog"
            @handleChangeSize="handleChangeSize"
            @handleChangeColor="handleChangeColor"
          />
      </div>
  </div>
      `,
  });
}

export default RenderProductPageContent;
